module.exports = __webpack_public_path__ + "img/Group 427320596.68d6fc2e.png";